import Vue from 'vue'
import Vuex from 'vuex'
import organization from './modules/organization'
import user from './modules/user'
import task from './modules/task'
import taskStatistics from './modules/taskStatistics'
// import createPersistedState from 'vuex-persistedstate';
import resultBase from './modules/resultBase';
import tabs from './modules/tabs';
import template from './modules/template';
import dhcp from './modules/dhcp'
import client from './modules/clientStore';
import folder from './modules/folder';
import basic from './modules/basic'
import consultation from './modules/consultation'
Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    organization: organization,
    user: user,
    task: task,
    taskStatistics: taskStatistics,
    resultBase: resultBase,
    tabs: tabs,
    template: template,
    dhcp: dhcp,
    client: client,
    folder: folder,
    basic,
    consultation: consultation,
  },
  //   plugins: [createPersistedState({
  //       storage:window.sessionStorage,
  //         reducer(val)  {
  //           console.log("持久化",val);
  //           return {
  //             // 只储存state中的assessmentData
  //             consultation: val.consultation
  //           }
  //         }
  //       })
  //   ]
})
